import React, { useEffect } from 'react';
import styles from './index.module.scss';
import PageLayout from 'layout/page';
import amplitude from 'service/amplitude';
import { useAppContext } from 'use-app';
import LoadingDialog from 'components/loading-dialog';
import SelectCard from 'distributor/npc/module/select-card';
import ButtonDialog from 'components/button-dialog';
import { ReactComponent as IconSetting } from 'assets/icon_action_white.svg';
import { useMochiPayFlowContext, CHANGE_SETTING_DIALOG_SHOW } from '../use-mochi-pay-flow';
import BindCard from 'distributor/npc/module/bind-card';

const SettingDialog = () => {
  const { state, dispatch, removeNpc } = useMochiPayFlowContext();

  const onRemoveCard = () => {
    amplitude.payment_linkCard_dialog_unlink_onClick();
    removeNpc();
    dispatch({ type: CHANGE_SETTING_DIALOG_SHOW, payload: false });
  };

  const onCloseDialog = () => {
    amplitude.payment_linkCard_dialog_cancel_onClick();
    dispatch({ type: CHANGE_SETTING_DIALOG_SHOW, payload: false });
  };

  return (
    <ButtonDialog
      title="確定解除連結付款方式？"
      horizonal
      items={[
        {
          content: '確定解除',
          theme: 'positive',
          onClick: onRemoveCard,
          beLoading: true,
        },
        {
          content: '取消',
          theme: 'cancel',
          onClick: onCloseDialog,
        },
      ]}
      isShow={state.settingDialogShow}
    >
      您將無法繼續使用停車場付款服務。
    </ButtonDialog>
  );
};

const MochiPaySetting = () => {
  const { state: appState } = useAppContext();
  const { state, dispatch, initialize, bindNpc } = useMochiPayFlowContext();
  const card = appState.me?.currentCreditCard;
  const currentNpcCard = card ? state.cards?.find(x => x.type === card.creditCardCategory.uid) || {} : {};

  useEffect(() => {
    initialize();
  }, []);

  const onSettingClick = () => {
    amplitude.payment_linkCard_confirm_onClick();
    dispatch({ type: CHANGE_SETTING_DIALOG_SHOW, payload: true });
  };

  return (
    <>
      <SettingDialog />
      <PageLayout>
        <LoadingDialog isShow={state.loading} />
        {card ? (
          <div className={styles['mochi-pay-setting']}>
            <div className={styles['body']}>
              <BindCard
                settingButton={<IconSetting className={styles.setting} onClick={onSettingClick} />}
                currentPoints={currentNpcCard?.redeemBonusPoints || 0}
                onSwitchClick={() => {
                  amplitude.payment_switchRedeemUse_onClick(
                    card.redeemBonusPoints.enableCreditPointRedeem ? 'off' : 'on'
                  );
                  bindNpc({
                    type: card.creditCardCategory.uid,
                    redeemDiscountState: !card.redeemBonusPoints.enableCreditPointRedeem,
                  });
                }}
                showPromotion={true}
                showSetting={true}
              />
            </div>
          </div>
        ) : (
          <SelectCard
            cards={state.cards}
            onClick={card => {
              amplitude.payment_linkCard_onClick(card.type);
              bindNpc({ type: card.type });
            }}
          />
        )}
      </PageLayout>
    </>
  );
};

export default MochiPaySetting;
